import * as React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Guideline} from '@epic-ui/icons';

import {Option} from './IntervalRadioGroup';
import {Tooltip} from '../../../../../../components';

import {LockIcon} from '../../../../../common/icon';

import {StyledInput, StyledContainer, StyledContentWrapper, StyledIconWrapper} from './styles';

export interface IntervalSelectPlaceholderProps {
    tooltip: string;
    value: Option;
}

const IntervalSelectPlaceholder: React.FC<IntervalSelectPlaceholderProps> = ({
    tooltip,
    value: {label}
}) => (
    <StyledInput>
        <StyledContainer>
            <LockIcon />
            <StyledContentWrapper>{label}</StyledContentWrapper>
            <Tooltip placement="top" title={tooltip}>
                <StyledIconWrapper>
                    <Guideline />
                </StyledIconWrapper>
            </Tooltip>
        </StyledContainer>
        <ExpandMoreIcon />
    </StyledInput>
);

export default IntervalSelectPlaceholder;
